<script setup lang="ts">
// EMITS
const emit = defineEmits<{
    click: [];
}>();

// COMPOSABLES
const { trackSalesContactOpenContactForm } = useTracking();

// METHODS
const onClick = (): void => {
    trackSalesContactOpenContactForm();
    emit('click');
};
</script>

<template>
    <UButton icon="lucide:mail" color="primary" size="xl" square @click="onClick" />
</template>
